(function () {

    'use strict';

    // Declare app level module which depends on views, and components

    angular.module('finansApp', [
        'ngResource',
        'ngCookies',
        'angular-click-outside',

        // services
        'finansApp.employeeService',
        'finansApp.courseService',
        'finansApp.courseSortService',
        'finansApp.courseFilterService',

        // controllers
        'finansApp.employeeListController',
        'finansApp.employeeFilterController',
        'finansApp.employeeMenuController',
        'finansApp.courseListController',
        'finansApp.courseSorterController',
        'finansApp.courseFilterController'
        
    ])
    .value('apiUrl', "/umbraco/api/")
    .config(function($locationProvider) {

        $locationProvider.html5Mode({
          enabled: true,
          rewriteLinks: false,
          requireBase: false
        });
    });

})();

